<template>
  <t-card max-width="600">
    <v-card-title>
      <v-row class="py-4 px-4">
        <v-col>
          <span v-if="dialog.config.hasTitle">CRIAR CONTA</span>
        </v-col>
        <v-spacer />
        <v-btn v-if="dialog.config.hasCloseButton" icon elevation="0">
          <v-icon size="small" @click="close">
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="center" class="my-4">
        <v-col
          cols="8"
          sm="5"
          md="4"
          lg="6"
        >
          <t-logo width="100%" />
        </v-col>
      </v-row>
      <form-verify-user v-if="!verified" @verified="onVerifyUser($event)" />
      <form-new-user
        v-else
        ref="form"
        :loading="loader.loading('button')"
        @submit="createUser"
        @cancel="verified = false"
      />
    </v-card-text>
  </t-card>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from "vue";
import type { ComponentPublicInstance } from "vue";
import FormNewUser from "@/components/User/FormNewUser.vue";
import FormVerifyUser from "@/components/User/FormVerifyUser.vue";
import TCard from "@/components/core/TCard.vue";
import TLogo from "@/components/core/TLogo.vue";
import { TrackableEvent } from "@/analytics/TrackableEvents";
import { useAnalytics } from "@/plugins/analytics";
import { useDialog } from "@/stores/dialog";
import { useSnackbar } from "@/stores/snackbar";
import { useUserStore } from "@/stores/user";
import { useLoader } from "@/stores/loader";

type ResetableForm = ComponentPublicInstance & { reset: () => undefined };

defineOptions({
  name: "UserRegister",
});

// Composables
const userStore = useUserStore();
const analytics = useAnalytics();
const dialog = useDialog();
const snackbar = useSnackbar();
const loader = useLoader();

// Refs
const verified = ref(false);
const form = useTemplateRef<ResetableForm>("form");

// Methods

const close = () => {
  dialog.hide();
};

const createUser = async () => {
  try {
    loader.increment("button");

    await userStore.register();

    snackbar.show("Cadastro realizado com sucesso!", "success");

    analytics.collect(
      TrackableEvent.Register,
      { params: { method: "password" } },
    );

    close();

    dialog.show("/email/verification", {
      hasTitle: true,
      hasCloseButton: true,
      persistent: false,
    });
  } catch (e) {
    snackbar.error(e);
  } finally {
    loader.decrement("button");
  }
};

const onVerifyUser = (userExists: boolean) => {
  if (userExists) {
    dialog.show("/recover");
    snackbar.show("CPF já cadastrado em nossa base, recupere sua senha!", "error");
    return;
  }

  verified.value = true;
};
</script>
